import { argsSchemaToParameters } from '@/features/tools/schema'
import type { AppTool, ToolParameterField } from '@/features/tools/types'
import { DEFAULT_TOOL_ICON } from '@/features/tools/icons'

export interface ToolDraft {
  name: string
  description: string
  angelica_instructions: string
  angelica_enabled: boolean
  david_instructions: string
  icon: string
  parameters: ToolParameterField[]
  webhook_url: string
  webhook_auth_header: string
  webhook_auth_secret: string
  david_enabled: boolean
  enabled: boolean
}

export function draftFromOrgTool(tool?: AppTool): ToolDraft {
  return {
    name: tool?.name ?? '',
    description: tool?.description ?? '',
    angelica_instructions: tool?.angelica_instructions ?? '',
    angelica_enabled: tool?.angelica_enabled ?? false,
    david_instructions: tool?.david_instructions ?? '',
    icon: tool?.icon ?? DEFAULT_TOOL_ICON,
    parameters: argsSchemaToParameters(tool?.args_schema),
    webhook_url: tool?.execution_target === 'webhook' ? tool.webhook_url : '',
    webhook_auth_header:
      tool?.execution_target === 'webhook'
        ? (tool.webhook_auth_header ?? '')
        : '',
    webhook_auth_secret: '',
    david_enabled: tool?.david_enabled ?? false,
    enabled: tool?.enabled ?? true,
  }
}
